import { useEffect, useState } from "react";
import { NavLink, Link, useNavigate } from "react-router-dom";
import { Box, ButtonGroup, IconButton, Table, Tooltip } from "@mui/joy";
import { authenticatedApi } from "api";
import { formatDate } from "@utils/dates";
import { ReportDeleteButton } from "@components/reports/ReportDeleteButton";
import LaunchRoundedIcon from '@mui/icons-material/LaunchRounded';
import DownloadRoundedIcon from '@mui/icons-material/DownloadRounded';
import MaestroLoader from "@components/MaestroLoader";
import AbstractObjectRelationship from "@components/objects/AbstractObjectRelationship";
import { useDocumentTitle } from "@uidotdev/usehooks";

function SavedReports() {
    useDocumentTitle(`Saved Reports | Maestro Community Manager`);

    const navigate = useNavigate();

    const [recentReports, setRecentReports] = useState([]);
    const [isLoadingRecent, setIsLoadingRecent] = useState(false);
    const [isError, setIsError] = useState(false)

    useEffect(() => {
        setIsLoadingRecent(true);

        const endpoint = window.location.hostname.indexOf('conductor') !== -1 ? 'conductor-reports' : 'reports';
        authenticatedApi.get(endpoint+'?orderby=created_at&order=desc&per_page=-1').then(response => {
            if(response.data.hasOwnProperty('data')) {
                setRecentReports(response.data.data);
            } else {
                // console.log(response);
                setIsError(true);
            }
        }).finally(() => {
            setIsLoadingRecent(false);
        });
    }, []);

    const isSearchValid = (search) => {
        // old searches didn't have a community key
        return search.hasOwnProperty('communities');
    }

    return (
        <Box p={2}>
            <AbstractObjectRelationship
                title="Saved Reports"
                sx={{
                    '--mm-card-height': 'auto',
                }}
            >
                {isLoadingRecent === true && (
                    <Box p={2} display={'flex'} justifyContent={'center'}>
                        <MaestroLoader />
                    </Box>
                )}
                {isLoadingRecent !== true && (<>
                {recentReports.length > 0 && (
                    <Table sx={{tableLayout: 'auto'}}>
                        <thead>
                        <tr>
                            <th>Name</th>
                            <th>Created By</th>
                            <th>Created At</th>
                            <th></th>
                        </tr>
                        </thead>
                        <tbody>
                        {recentReports.map((report, index) => (
                            <tr key={index}>
                                <td>{report.name}</td>
                                <td>{report.created_by ? `${report.created_by.first_name} ${report.created_by.last_name}` : 'N/A'}</td>
                                <td>{formatDate(report.created_at)}</td>
                                <td style={{textAlign: 'right'}}>
                                    <ButtonGroup
                                        color="neutral"
                                        variant="outlined"
                                        size="sm"
                                        sx={{
                                            '--IconButton-size': '1.5rem',
                                            bgcolor: 'background.surface',
                                            verticalAlign: 'sub',
                                            display: 'inline-flex',
                                            // ml: 0.5,
                                            'svg': {
                                                width: '1.05rem',
                                                height: '1.05rem',
                                            }
                                        }}
                                    >
                                        {report.searches && isSearchValid(report.searches) && (
                                            <Tooltip title={'Run Search'}>
                                                <IconButton
                                                    color="neutral"
                                                    variant="outlined"
                                                    size="sm"
                                                    sx={{
                                                        '--IconButton-size': '1.5rem',
                                                        bgcolor: 'background.surface',
                                                        verticalAlign: 'sub',
                                                        // ml: 0.5,
                                                        'svg': {
                                                            width: '1.05rem',
                                                            height: '1.05rem',
                                                        }
                                                    }}
                                                    onClick={() => {
                                                        navigate('../new', { state: { savedSearch: report.searches } });
                                                    }}
                                                >
                                                    <LaunchRoundedIcon/>
                                                </IconButton>
                                            </Tooltip>
                                        )}
                                        {report.files && report.files.length > 0 && (
                                            <Tooltip title={'Download PDF'}>
                                                <IconButton
                                                    color="neutral"
                                                    variant="outlined"
                                                    size="sm"
                                                    sx={{
                                                        '--IconButton-size': '1.5rem',
                                                        bgcolor: 'background.surface',
                                                        verticalAlign: 'sub',
                                                        // ml: 0.5,
                                                        'svg': {
                                                            width: '1.05rem',
                                                            height: '1.05rem',
                                                        }
                                                    }}
                                                    component="a"
                                                    href={report.files[(report.files.length - 1)].url}
                                                    target="_blank"
                                                >
                                                    <DownloadRoundedIcon/>
                                                </IconButton>
                                            </Tooltip>
                                        )}
                                        <ReportDeleteButton report={report} reports={recentReports} setReports={setRecentReports} />
                                        {/*
                                        <a className="btn btn-sm btn-danger" ng-click="deleteReport(row)" uib-tooltip="Delete Search" tooltip-placement="left" tooltip-append-to-body="true">
                                            <i className="icon-trash2"></i>
                                        </a>
                                        */}
                                    </ButtonGroup>
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </Table>
                )}

                {recentReports.length === 0 && !isError && (
                    <div className="wrapper text-center" style={{padding: '1rem'}}>
                        <em>You don't have any recently saved reports.</em>
                        <br/>
                        <Link to="/reports/new" className="btn btn-default spacer-top">Run New Report</Link>
                        {/* <a href="/saved" className="">Run New Report</a> */}
                    </div>
                )}

                {isError && (
                    <div className="wrapper text-center">
                        <em>There was an error loading your saved reports.</em>
                    </div>
                )}
                </>)}
            </AbstractObjectRelationship>
        </Box>
    );
}

export default SavedReports;
